import React, { Component } from 'react';
import { connect } from 'react-redux';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {
  getClients,
  getNextClientPage,
  getPrevClientPage,
  addClientToastClose,
  switchSelectedTab,
  setClientTab,
  resetPaginationToNull,
  clearSearchQueryText
} from '../actions/userActions';
import ClientListingItem from './ClientListingItem';
import { userStyles } from '../styles';
import {
  WithStyles,
  Grid,
  withStyles,
  Typography,
  Paper,
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';

import TabularData from './TabularData';
import { withRouter } from 'react-router-dom';

interface ClientListingProps extends WithStyles<typeof userStyles> {
  dialogOpen: boolean;
  dialogCloseHandler: Function;
  clientData: any;
  getClients: any;
  totalPages: number;
  clientAddedSuccessfully: any;
  addClientToastClose: any;
  loggedInUserData: any;
  searchQuery: any;
  switchSelectedTab: Function,
  setClientTab: Function,
  resetPaginationToNull: Function,
  pageNumber: number;
  history: any;
  clearSearchQueryText: Function;
}
class ClientListing extends Component<ClientListingProps> {
  state = {
    currentPage: 1,
    previousPages: [],
    nextPages: [2, 3, 4, 5],
    lastPage: null,
    paginationElements: null,
    searchQuery: ''
  };

  handleChangePage() {}

  componentDidMount() {
    console.log('Client Listing', this.props.searchQuery)
    this.props.clearSearchQueryText();
    this.props.getClients({pageNumber: 1, searchQuery: ''});
    setTimeout(() => { this.props.addClientToastClose()} , 4000);

    this.setState({
      paginationElements: this.generatePaginationElements()
    })

  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if(prevProps.clientData !== this.props.clientData) {
      console.log('Client Data Updated!')
      this.setState({
        paginationElements: this.generatePaginationElements()
      })
    //  this.setCurrentPage(1);
  }
  console.log(prevProps.pageNumber);
  console.log(this.props.pageNumber);
  if(prevProps.pageNumber !== this.props.pageNumber){
      this.props.history.push('/userManagement');
      this.props.switchSelectedTab("Clients");
      this.props.setClientTab(true);
      this.props.resetPaginationToNull();
    }

    if(prevProps.totalPages !== this.props.totalPages){
      console.log('Total Pages: ', this.props.totalPages)
      this.setCurrentPage(1);
    }

    if(prevProps.searchQuery !== this.props.searchQuery){
      console.log('Search Query: ', this.props.searchQuery)
      this.setState({
        searchQuery: this.props.searchQuery
      })
    }
  }

  constructor(props: ClientListingProps) {
    super(props);
  }

  setCurrentPage = (pageNumber: any) => {
    
    
    const currentPage = pageNumber;
    this.props.getClients({pageNumber: pageNumber, searchQuery: this.props.searchQuery});
    const prevPages = this.setPrevPages(currentPage);
    const nextPages = this.setNextPages(currentPage);
    
    this.setState({
      ...this.state,
      currentPage: currentPage,
      previousPages: prevPages,
      nextPages: nextPages,
      lastPage: this.props.totalPages,
    }, () => console.log('State::::::::::::', this.state));
  };

  setPrevPages = (currentPage: any) => {
    
    let previousPages: any = [];

    switch (currentPage) {
      case 1:
        previousPages = [];
        break;
      case currentPage:
        let maxPreviousPages = 2;
        while (currentPage !== 1 && maxPreviousPages !== 0) {
          currentPage = currentPage - 1;
          previousPages.push(currentPage);
          maxPreviousPages -= 1;
        }
        let index = previousPages.indexOf(1);
        if (index > -1) {
          previousPages.splice(index, 1);
        }
        break;
      default:
        previousPages = [];
    }
    
    return previousPages;
  };

  setNextPages = (currentPage: any) => {
    
    let nextPages: any = [];

    switch (currentPage) {
      case 1:
        // nextPages = [2, 3, 4, 5];
        if (this.props.totalPages > 5) {
          nextPages = [2, 3, 4, 5];
        } else {
          for (let i = 2; i < this.props.totalPages; i++) {
            nextPages.push(i);
          }
        }
        break;
      case currentPage:
        let maxNextPages = 2;
        while (currentPage !== this.props.totalPages && maxNextPages !== 0) {
          currentPage = currentPage + 1;
          nextPages.push(currentPage);
          maxNextPages -= 1;
        }
        let index = nextPages.indexOf(this.props.totalPages);
        if (index > -1) {
          nextPages.splice(index, 1);
        }
        break;
      default:
        nextPages = [2, 3, 4, 5];
    }

    return nextPages;
  };

  nextPage = (currentPage: any) => {
    
    let nextPage = currentPage + 1;
    
    if (nextPage <= this.props.totalPages) {
      this.setCurrentPage(nextPage);
    }
  };

  prevPage = (currentPage: any) => {
    
    let prevPage = currentPage - 1;
    
    if (prevPage !== 0) {
      this.setCurrentPage(prevPage);
    }
  };

  generatePaginationElements = () => {
    const {classes} = this.props;
    // Add UI
    let firstPage = <Grid onClick={() => {this.setCurrentPage(1)}}>
                            {1}
                    </Grid>
    let currentPage =  <Grid 
                              className={classes.activeNumber} 
                              onClick={() => {this.setCurrentPage(this.state.currentPage)}}
                        >
                        {this.state.currentPage}
                       </Grid>
    let morePages = <Grid onClick={() => {}}>
                      ...
                    </Grid>

    let previousPages = this.state.previousPages.map((page, index) => {
      return  <Grid key={index} onClick={() => {this.setCurrentPage(page)}}>
                {page}
              </Grid>
    });
    previousPages = previousPages.reverse();

    let nextPages = this.state.nextPages.map((page, index) => {
      return <Grid key={index} onClick={() => {this.setCurrentPage(page)}}>
                {page}
              </Grid>
    })

    let lastPage = <Grid onClick={() => {this.setCurrentPage(this.props.totalPages)}}>
                    {this.props.totalPages}
                    </Grid>

    return (
      <span className={classes.numberContainer}>
        {this.props.totalPages > 1 &&<span onClick={() => this.prevPage(this.state.currentPage)}>
          <ArrowBackIosIcon />
        </span>}
         { this.state.currentPage !== 1 ? firstPage : null } 
         {  this.state.currentPage !== 1 && 
            this.state.currentPage > 4 &&
            !previousPages.includes(firstPage) &&
            this.props.totalPages > 4
            ? morePages 
            : null}       
         {this.props.totalPages >= 4 && previousPages}
         {this.props.totalPages !== 1 && currentPage}
         {this.props.totalPages >= 2 && nextPages}
         {  this.state.currentPage !== this.state.lastPage && 
            !nextPages.includes(lastPage) &&
            this.props.totalPages > 4
            ? morePages
            : null}
         {this.state.currentPage !== this.state.lastPage &&
         this.props.totalPages !== 1 && 
          this.props.totalPages >= 2
        ? lastPage : null}
        {this.props.totalPages > 1 && <span onClick={() => this.nextPage(this.state.currentPage)}>
        <ArrowForwardIosIcon />
        </span>}
      </span>
    );
  };

  handleToaster = () => {
    
    this.props.addClientToastClose();
  };

  render() {
    const { classes } = this.props;
       
    let headers, dataKeys: any, data, action, permission;
    // const paginationElements = this.generatePaginationElements();

    headers = ['S.No', 'Name', 'Address', 'License Validity', 'Action'];

    dataKeys = ['_id', 'record.name', 'address', 'license'];

    data = this.props.clientData ? this.props.clientData : null;

    action = {
      isEdit: true,
      editURL: '/userManagement/editClient/',
    };

    permission = {
      isView: false,
    };

    return (
      <>
      {this.props.clientAddedSuccessfully && (
          <Grid
            className={[classes.customToaster, classes.successTooltip].join(
              ' '
            )}
          >
            <Typography variant="h6">
              <span>
                <CheckCircleIcon />
              </span>
              <span>Client Added Successfully</span>
              <span className="closeIcon" onClick={this.handleToaster}>
                <CloseIcon />
              </span>
            </Typography>
          </Grid>

        )
        
        }
        <Paper className={classes.customPaper}>
          <div className={classes.tableWrapper}>
            {this.props.clientData && this.props.clientData.length !== 0 && (
              <TabularData
                currentPage = {this.state.currentPage}
                headers={headers}
                dataKeys={dataKeys}
                data={data}
                action={action}
                permission={permission}
                searchQuery={this.state.searchQuery}
              />
            )}
          </div>
        </Paper>

        <Grid container justify="flex-end" alignItems="center">
          <Grid item>
            
            <Grid className={classes.numberContainer}>
             { this.state.paginationElements }
            </Grid>
            
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  clientData:
    state.clientManagement.clientMgmt.clientData &&
    state.clientManagement.clientMgmt.clientData.clients,
  totalPages:
    state.clientManagement.clientMgmt.clientData &&
    state.clientManagement.clientMgmt.clientData.totalPages,
    clientAddedSuccessfully: state.clientManagement.clientMgmt.clientAddedSuccessfully,
  loggedInUserData:
    state.loginData.userData &&
    state.loginData.userData.loggedInUserData,
  searchQuery: 
    state.clientManagement.clientMgmt.searchQuery,
  pageNumber: state.clientManagement.clientMgmt.pageNumber
});

const mapDispatchToProps = {
  getClients,
  getPrevClientPage,
  getNextClientPage,
  addClientToastClose,
  switchSelectedTab,
  setClientTab,
  resetPaginationToNull,
  clearSearchQueryText
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(withRouter(ClientListing)));
